import { render, staticRenderFns } from "./addPairDevice.vue?vue&type=template&id=06a8709a&"
import script from "./addPairDevice.vue?vue&type=script&lang=js&"
export * from "./addPairDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports